<template>
<ScalableElement
    v-model:scale="scale"
    @update:scale="pdfViewer.currentScale = $event"
>
  <div class="pdf-viewer">
    <div ref="viewerRef" class="pdf-viewer__container">
      <div
          id="viewer"
          class="pdf-viewer__container__inner-viewer pdfViewer"
      ></div>
    </div>
  </div>
</ScalableElement>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue'
import 'pdfjs-dist/build/pdf.worker.min.mjs'
import { getDocument } from 'pdfjs-dist'
import { PDFViewer, EventBus } from 'pdfjs-dist/web/pdf_viewer.mjs'
import 'pdfjs-dist/web/pdf_viewer.css'
import ScalableElement from './ScalableElement.vue'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
})

const viewerRef = ref(null)
const eventBus = new EventBus()
let pdfViewer

const loading = ref(true)
const renderError = ref(false)
const scale = ref(1)

const loadPdf = async () => {
  renderError.value = false
  loading.value = true

  try {
    const pdfDocument = await getDocument({
      url: props.src,
      cMapPacked: true,
      enableXfa: true,
    }).promise
    pdfViewer.setDocument(pdfDocument)
    scale.value = pdfViewer.currentScale
  } catch (e) {
    renderError.value = true
    console.error(e)
  }
  loading.value = false
}

watch(
    () => props.src,
    () => {
      loadPdf()
    },
)

onMounted(async () => {
  await nextTick()
  pdfViewer = new PDFViewer({
    container: viewerRef.value,
    eventBus,
  })
  return loadPdf()
})
</script>

<style scoped lang="scss">
.pdf-viewer {
  position: relative;
  width: 100%;
  height: 50vh;

  &__container {
    position: absolute;
    overflow: auto;
    width: 100%;
    height: 100%;
  }
}

.isFullscreen {
  .pdf-viewer {
    height: 100%;
  }
}
</style>
